import { API_HOST } from ".";

// localhostから叩くときは、stgに存在するpress_idを見るようにしてる
export const getPdfDownloadUrl = (press_id) => {
    if (process.env.REACT_APP_TARGET_ENV === 'local') return `http://${API_HOST}/pdf/5aa054cee6fe4e56a7c692471278803c/`;
    return `https://${API_HOST}/pdf/${press_id}/`;
}

